import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT_SLUG = "davangere-members-day-2026";

function headers(extra = {}) {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

export const conclaveApi = {
  rules: (event_id) =>
    axios.get(`${API}/admin/conclave/rules`, { params: { event_id }, headers: headers() }).then((r) => r.data),
  preview: (event_id, seed = 42) =>
    axios.get(`${API}/admin/conclave/preview`, { params: { event_id, seed }, headers: headers() }).then((r) => r.data),
  generate: (event_id, seed) =>
    axios.post(`${API}/admin/conclave/generate`, { event_id, ...(seed != null ? { seed } : {}) }, { headers: headers() }).then((r) => r.data),
  runs: (event_id, limit = 20) =>
    axios.get(`${API}/admin/conclave/runs`, { params: { event_id, limit }, headers: headers() }).then((r) => r.data),
  run: (run_id) =>
    axios.get(`${API}/admin/conclave/runs/${run_id}`, { headers: headers() }).then((r) => r.data),
  publish: (run_id) =>
    axios.post(`${API}/admin/conclave/runs/${run_id}/publish`, {}, { headers: headers() }).then((r) => r.data),
  rollback: (run_id, { force, reason } = {}) =>
    axios.delete(`${API}/admin/conclave/runs/${run_id}`, { params: { ...(force ? { force: true } : {}), ...(reason ? { reason } : {}) }, headers: headers() }).then((r) => r.data),
  tables: (event_id, round_number) =>
    axios.get(`${API}/admin/conclave/tables`, { params: { event_id, round_number }, headers: headers() }).then((r) => r.data),
  assignLeader: (body) => axios.post(`${API}/admin/conclave/table-leaders`, body, { headers: headers() }).then((r) => r.data),
  listLeaders: (event_id, round_number) =>
    axios.get(`${API}/admin/conclave/table-leaders`, { params: { event_id, ...(round_number != null ? { round_number } : {}) }, headers: headers() }).then((r) => r.data),
  unassignLeader: (id) => axios.delete(`${API}/admin/conclave/table-leaders/${id}`, { headers: headers() }).then((r) => r.data),
  diff: (run_id) => axios.get(`${API}/admin/conclave/runs/${run_id}/diff`, { headers: headers() }).then((r) => r.data),
};

export const leaderPublicApi = {
  tableDetail: (round, table) =>
    axios.get(`${API}/leader/tables/${round}/${table}`, { params: { event_slug: EVENT_SLUG } }).then((r) => r.data),
};
